import axios from 'axios';
import { resolveBackendBaseUrl } from '../lib/wsAuth';
import { isAdminPortalHost } from '../lib/adminPortal';

const api = axios.create({
  baseURL: resolveBackendBaseUrl(),
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('session_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (isAdminPortalHost()) config.headers['X-ReelIsle-Admin-Portal'] = '1';
  // Auto-generate idempotency key for POST requests
  if (config.method === 'post' && !config.headers['X-Idempotency-Key']) {
    config.headers['X-Idempotency-Key'] = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('session_token');
      const path = window.location.pathname;
      const isProtected = path.startsWith('/app') || path.startsWith('/admin');
      if (isProtected) {
        window.location.href = '/auth';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
